import { SpacebarKey } from '../../keyboard-key';
import { IS_FOCUSABLE_ATTRIBUTE } from '../../attributes';

/**
 * @specification
 * Adds role='checkbox'. This allows screen readers to handle the component as a checkbox button.
 * Adds attribute 'aria-checked=true' based on the property 'checked'.
 * Adds attribute 'aria-disabled=true' based on the property 'disabled'.
 * Adds attribute 'tabIndex=0' to 'root' slot.
 * Adds attribute 'data-is-focusable=true' to 'root' slot.
 */
export var checkboxBehavior = function checkboxBehavior(props) {
  var _root;
  return {
    attributes: {
      root: (_root = {
        'aria-checked': props.checked === 'mixed' ? 'mixed' : !!props.checked,
        'aria-disabled': props.disabled,
        role: 'checkbox',
        tabIndex: 0
      }, _root[IS_FOCUSABLE_ATTRIBUTE] = true, _root)
    },
    keyActions: {
      root: {
        performClick: {
          keyCombinations: [{
            keyCode: SpacebarKey
          }]
        }
      }
    }
  };
};
//# sourceMappingURL=checkboxBehavior.js.map
